import Forensics from './Forensics.page';

export default Forensics;
